module.exports = __webpack_public_path__ + "img/news.dee807d8.png";